import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Floor, FloorScheme, Tower } from '@pages/consorcios/consorcios.config';
import { Consorcista, ConsorcistasService } from '@pages/consorcios/consorcistas.service';
import { LoaderStoreService } from '@shared/services/loader-store.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { firstValueFrom } from 'rxjs';

export type selectedApartmet = {
    unit: string,
    floor: string,
    tower?: string
}

@Component({
    selector: 'app-consorcio-scheme',
    standalone: true,
    imports: [
        CommonModule, DialogModule, ButtonModule
    ],
    templateUrl: './consorcio-scheme.component.html',
    styleUrl: './consorcio-scheme.component.scss'
})
export class ConsorcioSchemeComponent {
    translate = inject(TranslateService);
    _t = (key: string) => this.translate.instant(key);
    consorcistaService = inject(ConsorcistasService);
    messageService = inject(MessageService)
    loaderStore = inject(LoaderStoreService);
    @Input() floors: Floor[] = [];
    //azotea que se muestra arriba de floors, solo en la creacion del consorcio (ahi se edita aparte y recien al guardar se suma a floors).
    //con torres se usa la azotea de cada torre (tower['azotea'])
    @Input() azotea?: Floor;
    @Input() activeFloors: Floor[] = [];
    @Input() towers: Tower[] = [];
    @Input() floorScheme: FloorScheme = 'number';
    @Input() hasTowers: boolean = false;
    @Input() selectFloor: string = '';
    @Output() selectFloorChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() selectApartment: string = '';
    @Input() selectedUnits: selectedApartmet[] = [];
    @Output() selectApartmentChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() selectTower: string = '';
    @Output() selectTowerChange: EventEmitter<string> = new EventEmitter<string>();
    inputTower?: Tower;
    @Output() onSelectEvent: EventEmitter<{ floor: string; apartment: string; tower?: string }> = new EventEmitter<{ floor: string; apartment: string; tower?: string }>();
    @Input() consorcioUid: string = '';
    showPopup: boolean = false;
    modalHeader: string = '';
    consorcistasInUnit: Consorcista[] = []
    async onSelect(floor: string, apartment: string, tower?: string) {
        if (this.consorcioUid) {
            try {

                this.modalHeader = 'Consorcistas en ';
                if (tower) {
                    this.modalHeader += 'Torre: ' + tower + ' ';
                }
                this.modalHeader += 'Piso: ' + floor + ' ' + 'Unidad: ' + apartment;
                this.loaderStore.set("loading", true)
                this.consorcistasInUnit = await firstValueFrom(this.consorcistaService.getByUnit(this.consorcioUid, floor, apartment))
                this.showPopup = true
            }
            catch (error) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: "Error al buscar consorcistas" });
            }
            finally {
                this.loaderStore.set("loading", false)

            }
        } else {
            this.onSelectEvent.emit({ floor, apartment, tower });
            this.selectFloorChange.emit(floor);
            this.selectApartmentChange.emit(apartment);
            if (tower) {
                this.selectTowerChange.emit(tower);
            }
        }
    }

    changeTower(tower: Tower) {
        this.inputTower = tower;
    }

    ngOnInit() {
        //por defecto elegir una torre si hay torres y no se selecciono ninguna
        if (this.hasTowers && this.towers.length > 0 && !this.selectTower) {
            this.changeTower(this.towers[0]);
        }

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['floors']) {
            this.floors = changes['floors'].currentValue;
        }
        if (changes['selectFloor']) {
            this.selectFloor = changes['selectFloor'].currentValue;
        }
        if (changes['selectApartment']) {
            this.selectApartment = changes['selectApartment'].currentValue;
        }
        if (changes['selectTower']) {
            this.selectTower = changes['selectTower'].currentValue;
        }
    }
    closeDialog() {
        this.consorcistasInUnit = [];
        this.showPopup = false;

    }
    checkIfFloorIsSelected(floor: string, unit: string, tower?: string): boolean {

        if (tower) {
            if (this.selectedUnits.some(apartment => apartment.tower === tower && apartment.floor === floor && apartment.unit === unit)) {
                return true
            }
        } else {
            if (this.selectedUnits.some(apartment => apartment.floor === floor && apartment.unit === unit)) {
                return true
            }
        }
        return false
    }

}
